import { render } from "./notifications.vue?vue&type=template&id=00f7d8a6&scoped=true&ts=true&lang=pug"
import script from "./notifications.vue?vue&type=script&lang=ts"
export * from "./notifications.vue?vue&type=script&lang=ts"

import "./notifications.vue?vue&type=style&index=0&id=00f7d8a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f7d8a6"]])

export default __exports__